import React, { useContext } from 'react';
import { hideSuggestedPopUp, suggestedResponsesImg } from '../chatUtils';
import { APIContext } from '../../contexts/APIContext';
import { SessionContext } from '../../contexts/SessionContext';

interface ResponseSuggestionsPopupProps {
  actionProvider: any;
}

const ResponseSuggestionsPopup: React.FC<ResponseSuggestionsPopupProps> = ({ actionProvider }) => {
  const { setIsPromptRetried } = useContext(SessionContext);
  const { userDetails, batchType } = useContext(APIContext);

  // Function to handle clicks on the suggestions
  const handleSuggestionClick = (suggestion: string) => {
    setIsPromptRetried(false);
    actionProvider.handleUserAction(suggestion);
    suggestedResponsesImg.setAttribute('src', '/icons/BulbIcon.svg');
  };

  const closeHandler = () => {
    hideSuggestedPopUp();
  };

  return (
    <div
      id="response-suggestions-popup"
      className="response-suggestions-popup-container absolute bottom-14 right-[14.78px] transform flex flex-col max-w-[700px] w-[93.5%] justify-center items-start z-50 border border-solid border-[#A100FF] shadow-[0_4px_6px_0_rgba(0,0,0,0.10)] bg-[#EAEAEA]"
    >
      <div className="flex flex-row justify-between w-[100%] pr-[10px]">
        <span className="pt-2 py-2 pl-4 text-[#000] not-italic font-graphik text-xs font-medium">
          Suggested Questions
        </span>
        <img
          src="/icons/Close.svg"
          alt="Send suggested prompt"
          className="send-btn cursor-pointer"
          onClick={closeHandler}
        />
      </div>
      <div className="pr-[10px]">
        <div className="h-[210px] overflow-y-auto scrollbar-webkit pr-[10px] pl-[10px]">
          {userDetails?.ConfigurationDetails?.PredefinedPrompts?.map((suggestion: any, index: number) => (
            <div
              key={index}
              className={`relative font-graphik text-base not-italic font-normal p-4 text-[#535353] text-start w-full flex justify-between items-center cursor-pointer ${
                batchType == 'batch' && 'not-clickable'
              }`}
              onClick={() => handleSuggestionClick(suggestion.PromptName)}
            >
              <div className="absolute left-4 right-0 bottom-0 h-[0.05rem] bg-[#CCC] w-[95%]"></div>
              <span>{suggestion.PromptName}</span>
              <img src="/icons/send2-new.svg" alt="Send suggested prompt" className="send-btn h-4 w-4" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResponseSuggestionsPopup;
